import { FC, SVGAttributes } from "react";

const ColoursIcon: FC<SVGAttributes<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M0 0H32V32H0z"
        transform="translate(-16 -429) translate(16 429)"
      />
      <g transform="translate(-16 -429) translate(16 429) translate(2 4)">
        <path
          stroke="#000"
          strokeWidth="2"
          d="M17.596 2.54l6.364 6.364-12.374 12.374c-.879.879-2.03 1.318-3.182 1.318-1.152 0-2.303-.44-3.182-1.318-.879-.879-1.318-2.03-1.318-3.182 0-1.151.44-2.303 1.318-3.182h0L17.596 2.54z"
        />
        <path
          fill="#FFF"
          stroke="#000"
          strokeWidth="2"
          d="M25 14v9H7.5c-1.243 0-2.368-.504-3.182-1.318C3.504 20.868 3 19.742 3 18.5c0-1.243.504-2.368 1.318-3.182C5.132 14.504 6.258 14 7.5 14H25z"
        />
        <path
          fill="#FFF"
          stroke="#000"
          strokeWidth="2"
          d="M13 1v17c0 1.38-.56 2.63-1.464 3.536C10.63 22.44 9.38 23 8 23c-1.38 0-2.63-.56-3.536-1.464C3.56 20.63 3 19.38 3 18h0V1h10z"
        />
        <rect width="2" height="2" x="7" y="18" fill="#000" rx="1" />
        <path fill="#000" d="M4 5H12V7H4zM4 10H12V12H4zM4 15H12V17H4z" />
      </g>
    </g>
  </svg>
);

export { ColoursIcon };
